import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const UsersListPage = lazy(() => import('./UsersListPage'));
const UserDetailPage = lazy(() => import('./UserDetailPage'));

export const userRoutes: RouteObject[] = [
  {
    path: 'users',
    element: (
      <ProtectedRoute action="users:view">
        <UsersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'users/:id',
    element: (
      <ProtectedRoute action="users:view">
        <UserDetailPage />
      </ProtectedRoute>
    ),
  },
];
